import type { DataGraphDef, DataGraphInstance, DataSourceDef, SceneDataContext } from '../../graph/dataGraph.js';
import type { EventGraphDef, RuntimeStateSchema } from '../../graph/eventGraph.js';
import type { SceneEventBindings } from '../../graph/eventGraph.js';
import type { SceneNodeId } from '../../scene/sceneState.js';
import type { RuntimeGraphKind, SvgPathShape } from '../../state/appState.js';

export interface SetRuntimeGraphCmd {
  type: 'runtime:setGraph';
  kind: RuntimeGraphKind;
  graphId: string;
  graph: DataGraphDef | EventGraphDef | null;
}

export interface SetDataOwnerCmd {
  type: 'data:setOwner';
  owner: { type: 'document' } | { type: 'scene'; nodeId: SceneNodeId };
  instance: DataGraphInstance | null;
}
export interface SetDataSourcesCmd { type: 'data:setSources'; sources: Record<string, DataSourceDef>; }
export interface SetShapesCmd { type: 'assets:setShapes'; shapes: Record<string, SvgPathShape>; }

export interface SetRuntimeStateCmd { type: 'runtime:setState'; schema: RuntimeStateSchema; }
export interface SetRuntimeModelCmd { type: 'runtime:setModel'; schema: RuntimeStateSchema; dataGraphs: Record<string, DataGraphDef>; eventGraphs: Record<string, EventGraphDef>; }
export interface SetSceneEventsCmd { type: 'event:setSceneEvents'; nodeId: SceneNodeId; events: SceneEventBindings | null; }
export interface SetSceneDataContextCmd { type: 'data:setSceneContext'; nodeId: SceneNodeId; context: SceneDataContext | null; }

export function createSetRuntimeGraphCommand(kind: RuntimeGraphKind, graphId: string, graph: DataGraphDef | EventGraphDef | null): SetRuntimeGraphCmd {
  return { type: 'runtime:setGraph', kind, graphId, graph: graph ? structuredClone(graph) : null };
}
export function createSetDataSourcesCommand(sources: Record<string, DataSourceDef>): SetDataSourcesCmd {
  return { type: 'data:setSources', sources: structuredClone(sources) };
}
export function createSetShapesCommand(shapes: Record<string, SvgPathShape>): SetShapesCmd {
  return { type: 'assets:setShapes', shapes: structuredClone(shapes) };
}

export function createSetRuntimeStateCommand(schema: RuntimeStateSchema): SetRuntimeStateCmd {
  return { type: 'runtime:setState', schema: structuredClone(schema) };
}
export function createSetRuntimeModelCommand(schema: RuntimeStateSchema, dataGraphs: Record<string, DataGraphDef>, eventGraphs: Record<string, EventGraphDef>): SetRuntimeModelCmd {
  return { type: 'runtime:setModel', schema: structuredClone(schema), dataGraphs: structuredClone(dataGraphs), eventGraphs: structuredClone(eventGraphs) };
}
export function createSetSceneEventsCommand(nodeId: SceneNodeId, events: SceneEventBindings | null): SetSceneEventsCmd {
  return { type: 'event:setSceneEvents', nodeId, events: events ? structuredClone(events) : null };
}
export function createSetSceneDataContextCommand(nodeId: SceneNodeId, context: SceneDataContext | null): SetSceneDataContextCmd {
  return { type: 'data:setSceneContext', nodeId, context: context ? structuredClone(context) : null };
}

export function createSetDataOwnerCommand(owner: SetDataOwnerCmd['owner'], instance: DataGraphInstance | null): SetDataOwnerCmd {
  return { type: 'data:setOwner', owner: { ...owner }, instance: instance ? structuredClone(instance) : null };
}
